import { z } from 'zod';

// ---------------------------------------------------------------------------
// Industry templates
// ---------------------------------------------------------------------------

/**
 * Industry templates a workspace can start from (sign-up, Settings, Hive provisioning). Each adds a
 * pipeline and starter sequences; the content lives in `@salesbee/domain` (`templates`).
 *
 * Ids are the NorthOps vertical ids; `general` is the built-in "Outbound sales" pipeline. This list
 * is mirrored in `_shared/catalog.json` as `templates.salesbee.industries` (a drift test compares
 * them), so change both together.
 */
export const INDUSTRY_TEMPLATES = [
  { id: 'general', label: 'General sales' },
  { id: 'real-estate', label: 'Real Estate' },
  { id: 'financial-advisor', label: 'Financial Advisor' },
  { id: 'insurance-agency', label: 'Insurance Agency' },
  { id: 'recruitment-staffing', label: 'Recruitment / Staffing' },
] as const satisfies readonly { id: string; label: string }[];

export type IndustryTemplateId = (typeof INDUSTRY_TEMPLATES)[number]['id'];
export const INDUSTRY_TEMPLATE_IDS = INDUSTRY_TEMPLATES.map((t) => t.id) as [
  IndustryTemplateId,
  ...IndustryTemplateId[],
];
export const industryTemplateId = z.enum(INDUSTRY_TEMPLATE_IDS);

export function isIndustryTemplateId(value: unknown): value is IndustryTemplateId {
  return typeof value === 'string' && (INDUSTRY_TEMPLATE_IDS as readonly string[]).includes(value);
}

export const applyTemplateInput = z.object({ id: industryTemplateId });
